<div id="popup">
  <div class="title-head index-head" fxLayout="row" fxLayoutAlign="space-between center">
    <span style="color: white; padding-left: 15px;">
      {{ data?.dialogTitle || ('Update Sub-Status: ' + data?.nodeName) }}
    </span>
    <button mat-icon-button (click)="onCancel()" style="color: white;">
      <mat-icon>
        close
      </mat-icon>
    </button>
  </div>
  <mat-dialog-content [ngStyle.lt-md]="'max-height: 100%'"
    style="margin: 0px; padding: 0px; max-height: 75vh; overflow-y: auto;">
    <div class="padding-11" style="padding: 15px;">
      <div fxLayout="column">

        <div *ngIf="formInit" fxFlex style="margin-bottom: 20px; width: 100%;">
          <simple-dynamic-form [layout]="1" [formValue]="patchValues" (submitLeadDetail)="saveNew($event)"
            [status]="data?.nodeName" [formType]="'outline'" [type]="2" (submit)="onFormSubmitted($event)"
            [fields]="regConfig">
          </simple-dynamic-form>
        </div>

        <div style="margin-bottom: 20px;">
          <mat-form-field appearance="outline" style="width: 100%;">
            <mat-label>Notes</mat-label>
            <textarea matInput [(ngModel)]="notes" rows="4" placeholder="Enter notes..."
              [required]="data.requireNotes"></textarea>
            <mat-error *ngIf="data.requireNotes && (!notes || notes.trim() === '')">Notes are required for this
              status.</mat-error>
          </mat-form-field>
        </div>

        <div style="margin-bottom: 20px;">
          <app-after-sales-document-upload [existingDocuments]="documents"
            [required]="data.requireImages || data.requireDocuments" (documentsChange)="onDocumentsChange($event)">
          </app-after-sales-document-upload>

          <div *ngIf="(data.requireImages || data.requireDocuments) && documents.length === 0"
            style="color: #f44336; font-size: 12px; margin-top: 5px;">
            At least one document is required for this status.
          </div>
        </div>

      </div>

      <div class="padding-top10" fxLayoutAlign="end center" fxLayoutGap="10px">
        <button mat-raised-button (click)="onCancel()" tabindex="-1">Cancel</button>
        <button [disabled]="!isValid || text === 'Processing...'" (click)="onSave()" mat-raised-button color="primary">
          {{ text === 'Processing...' ? text : (data?.buttonText || text) }}
          <mat-icon *ngIf="text === 'Processing...'" style="margin-left: 5px;">
            <mat-spinner color="accent" diameter="20"></mat-spinner>
          </mat-icon>
        </button>
      </div>
    </div>
  </mat-dialog-content>
</div>